import moment from "moment";

export function formatDate(date) {
  return date && date !== ""
    ? moment(date).format("MM/DD/YYYY hh:mm:ss A")
    : "";
}



// WEBPACK FOOTER //
// ./src/store/reducers/formatDate.js